const enterpriseIds = {    
    qualityassurance: 'l-tt_qualityassurance',
    dellearningframework: 'dellearningframework',
    admin_placeholder: 'aayushi.bharti'    
}
const domain = 'accenture.com';

const qualityassurance = `${enterpriseIds.qualityassurance}@${domain}`;
const dellearningframework = `${enterpriseIds.dellearningframework}@${domain}`;
const adminPlaceholder = `${enterpriseIds.admin_placeholder}@${domain}`;

export default {qualityassurance,dellearningframework,adminPlaceholder}